export default __webpack_public_path__ + "static/media/bg-all-communities.81407fa1.jpg";